import * as React from 'react';
import * as Algolia from 'algoliasearch';
import * as Autosuggest from 'react-autosuggest';
import * as Food from '../../domain/Food';
import logo from '../../logo-200w.png';
import algolia_logo from '../../search-by-algolia.png';

const client = Algolia('XXT4KN3BWH', '0e3fb6d4dfce19b09a2a13ab9a112e9b');

const getSuggestionValue = (food: Food.Food) => food.longDesc;
const renderSuggestion = (food: Food.Food, {}: { query: string, isHighlighted: boolean }) => (
  <div dangerouslySetInnerHTML={{__html: food._highlightResult.longDesc.value}} />
);
/*
function renderSuggestion(food: Food.Food, { query }: { query: string }) {
  const suggestionText = food.longDesc;
  const matches = AutosuggestHighlightMatch(suggestionText, query);
  const parts = AutosuggestHighlightParse(suggestionText, matches);

  return (
    <span className={'suggestion-content ' + suggestion.twitter}>
      <span className="name">
        {
          parts.map((part, index) => {
            const className = part.highlight ? 'highlight' : null;

            return (
              <span className={className} key={index}>{part.text}</span>
            );
          })
        }
      </span>
    </span>
  );
}
*/

function renderInputComponent(inputProps: Object): JSX.Element {
  return <input {...inputProps} type="search" />;
}

type InputMethod = 'down' | 'up' | 'escape' | 'enter' | 'click' | 'type';

type SearchProps = {searchText: string, setFood: (food: Food.Food, searchText: string) => void};
type SearchState = {searchText: string, suggestions: Food.Food[]};

class Search extends React.Component<SearchProps, SearchState> {
  searchInput: HTMLInputElement | null;

  constructor(props: SearchProps) {
    super(props);
    this.state = {searchText: props.searchText, suggestions: []};

    this.focusSearch = this.focusSearch.bind(this);
    this.searchChange = this.searchChange.bind(this);
    this.searchCallback = this.searchCallback.bind(this);
    this.search = this.search.bind(this);
    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this);
    this.storeInputReference = this.storeInputReference.bind(this);
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this);
    // this.handleSearch = this.handleSearch.bind(this);
  }

  componentWillReceiveProps(nextProps: SearchProps): void {
    if (this.props === nextProps) { return; }

    this.setState({searchText: nextProps.searchText, suggestions: []});
  }

  onSuggestionSelected(event: React.FormEvent<HTMLFormElement>, { suggestion }: { suggestion: Food.Food }): void {
    // console.warn('onSuggestionSelected ' + suggestion.longDesc);
    this.setState({ suggestions: [suggestion] });
    this.props.setFood(suggestion, this.state.searchText);
  }

  storeInputReference(autosuggest: Autosuggest | null): void {
    if (autosuggest !== null) {
      // tslint:disable-next-line
      this.searchInput = (autosuggest as any).input;
    }
  }

  focusSearch(): void {
    // Explicitly focus the text input using the raw DOM API
    if (this.searchInput) { this.searchInput.focus(); }
  }

  componentDidMount(): void {
    this.focusSearch();
    let strLength = this.state.searchText.length * 2;
    if (this.searchInput) {
      this.searchInput.setSelectionRange(strLength, strLength);
    }
  }

  searchChange(event: React.FormEvent<HTMLInputElement>, params?: {newValue: string, method: InputMethod}): void {
    // console.warn('searchChange ' + (params && params.method) + ' ' + (params ? params.newValue : ''));
    if (params === undefined) {
      this.search('');
      return;
    }
    switch (params.method) {
      // not selected yet
      case 'type':
        this.search(params.newValue);
        break;

      // don't search
      case 'up':
        break;
      case 'down':
        break;

      // all otherwise mean selected. Don't actually search, let the suggestion event fire
      case 'click':
        break;
      case 'enter':
        break;
      case 'escape':
        break;
      default:
        break;
    }
  }

  // TODO: debounce this
  search(searchText: string): void {
    // console.warn('search: ' + searchText);
    this.setState({searchText: searchText});

    if (searchText.length > 3) {
      const queries = [{
        indexName: 'sr28',
        query: searchText,
        params: {}
      }];
      client.search(queries, this.searchCallback);
    }
  }

  searchCallback(err: Error, res: Algolia.AlgoliaMultiResponse): void {
    if (err) {
        console.warn(err);
        return;
    }
    this.setState({ suggestions: res.results[0].hits });
  }

  // Autosuggest will call this function every time you need to update suggestions.
  onSuggestionsFetchRequested({ value, reason }: { value: string, reason: string }): void {
    // console.warn('fetchRequested: ' + reason + ' ' + value);
    if (reason === 'input-focused'
     || reason === 'suggestions-revealed'
     || reason === 'suggestion-selected') {
      // console.warn('fetchRequested: skip');
      return;
    }

    // console.warn('fetchRequested: search');
    this.search(value);
  }

  render() {
    const {searchText, suggestions} = this.state;
    const inputProps = {
      value: searchText,
      onChange: this.searchChange
    };

    return (
      <div ng-controller="SearchController">
        <div id="search-bar">
          <table>
              <tbody>
                 <tr>
                   <td>
                     <table>
                       <tbody>
                           <tr>
                             <td>
                               <a href="/">
                                 <img src={logo} />
                               </a>
                             </td>
                           </tr>
                           <tr>
                             <td>
                               { (suggestions.length > 0) && (
                                 <img className="algolia-credit" src={algolia_logo} />
                               ) }
                             </td>
                           </tr>
                       </tbody>
                     </table>
                   </td>
                   <td>
                     <Autosuggest
                       suggestions={suggestions}
                       alwaysRenderSuggestions={true}
                       renderSuggestion={renderSuggestion}
                       onSuggestionSelected={this.onSuggestionSelected}
                       onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                       getSuggestionValue={getSuggestionValue}
                       inputProps={inputProps}
                       renderInputComponent={renderInputComponent}
                       ref={this.storeInputReference}
                     />
                   </td>
                 </tr>
              </tbody>
          </table>
        </div>
        { /*
        <div id="suggest" className="ng-cloak" ng-show="suggestions.length">
          <p>
            No foods Found! You could try one of these searches:
          </p>
          <ul id="suggestions" ng-repeat="suggestion in suggestions">
            <li>
              <a ng-click="takeSuggestion(suggestion)" ng-bind="suggestion" />
            </li>
          </ul>
        </div>
        */ }
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/feature/search/Search.tsx